import { debounce } from '../utils/_debounce'

export default function CartAutoUpdate () {
  const triggerUpdate = debounce(() => {
    const updateBtn = document.querySelector('.woocommerce-cart-form [name="update_cart"]')
    if (updateBtn) updateBtn.click()
  }, 500)

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name*="[qty]"]')) {
      triggerUpdate()
    }
  })
}
